import { useConstructorContextState } from './useConstructorContextState';
import { get } from 'lodash';

export const useGetWhitelabelName = (): string => {
  const state = useConstructorContextState();

  return get(state, ['whitelabelName'], '');
};
